import React, {Fragment, Component} from "react";
import {TextField, TextareaField, ErrorMessage, Loader} from 'react-fields';
import CheckboxField from "../../base/checkbox";
import GroupSelectField from "../../base/groupSelectField";
import feedbackAPI from '../../api/feedbackAPI';
import HoverButton from "../../buttons/HoverButton";
import AvatarSelector from "./avatarSelector";

export default class TestimonialForm extends Component {

    state = {
        isLoading: false,
        testimonial: { ...this.props.testimonial, errors: {} }
    };

    submit = () => {
        this.setState({isLoading: true});
        let errors = {};
        let testimonial = this.state.testimonial;
        if (!testimonial.text) {
            errors['text'] = "Text can't be blank";
        }
        if (!testimonial.name) {
            errors['name'] = "Name can't be blank";
        }
        if (!testimonial.result) {
            errors['result'] = "Result can't be blank";
        }
        if (!testimonial.allow_show) {
            errors['allowShow'] = "Result can't be blank";
        }
        if (Object.keys(errors).length) {
            testimonial.errors = errors;
            this.setState({testimonial: testimonial, isLoading: false});
            return;
        }
        const groupCode = testimonial.result.split('_')[0];
        const selectedGroup = this.props.testimonial.available_results.find(group => group.code === groupCode);
        let selectedResult = !!selectedGroup ? selectedGroup.items.find(item => item.value === testimonial.result) : {};
        testimonial['result_type'] = selectedResult['result_type'];
        testimonial['result_id'] = selectedResult['result_id'];
        testimonial['result_name'] = selectedResult['result_name'];
        testimonial['score'] = selectedResult['score'];

        feedbackAPI.sendTestimonial(testimonial, this.props.onSuccess, (errors) => this.setState({isLoading: false, testimonial: {...this.state.testimonial, errors: errors} }));
    };

    onChange = (e) => {
        let testimonial = this.state.testimonial;
        const attribute = e.target.name;
        testimonial[attribute] = attribute === 'allow_show' ? e.target.checked : e.target.value;
        testimonial.errors[attribute] = '';
        this.setState({testimonial: testimonial})
    };

    render () {
        const form = this.state.testimonial;
        if (this.state.avatarSelector) {
            return <AvatarSelector value={form.avatar_icon} onSelect={(icon) => this.setState({testimonial: {...form, avatar_icon: icon}, avatarSelector: false})} />
        }
        return (
            <Fragment>
                {this.state.isLoading ? <Loader /> : null }
                <h3 className="feedback__msg">Submit Testimonial</h3>
                <p className={'feedback__txt'}>Feature and let others know about your experience!</p>
                <div className={'feedback__avatar-selector-box grid-x align-middle'}>
                    <div className={'cell shrink'}>
                    <div className={'testimonials__pic'}>
                        <div className={`avatar-icon ${form.avatar_icon}`} />
                    </div>
                    </div>
                    <div className={'cell auto text-left'}>
                        <p className="testimonials__commenter">Choose your character</p>
                    </div>
                    <div className={'cell shrink'}>
                        <HoverButton className={'button--dark-gray'} onClick={() => this.setState({avatarSelector: true})}>Select avatar</HoverButton>
                    </div>
                </div>
                <div className={'feedback__textarea form-gray text-left'}>
                    <label htmlFor='name'>Display name</label>
                    <TextField name='name' value={form.name} placeholder='Name*'
                               onChange={this.onChange} errorMessage={form.errors.name} />

                    <label htmlFor='text'>Testimonial <span className={'note'}>(max. 300 words)</span></label>
                    <p className={'sub-label'}>What did you like the most? Was it the reporting, recommendations, or entire test experience?</p>
                    <TextareaField name='text' className="vertical-resize" placeholder="Let us know what you think about your overall experience, including your test results and career matches." rows={5}
                                   onChange={this.onChange} value={form.text} errorMessage={form.errors.text}  />

                    <label htmlFor='result'>Share my:</label>
                    <GroupSelectField name='result' selected={form.result}
                                 options={form.available_results}
                                 onChange={this.onChange} errorMessage={form.errors.result}
                                 className='label-icon-right select-label' placeholder="Select test score or match*" />
                </div>


                <div className={'grid-x'}>
                    <div className={'cell auto input-container'}>
                    <div className={'form-gray text-left'}>
                        <CheckboxField name='allow_show' value={form.allow_show}
                                  onChange={this.onChange} label='I allow my testimonial to be featured on the website' errorMessage={form.errors.allowShow} />
                    </div>
                    </div>
                    <div className={'cell shrink'}>
                        <HoverButton className={'button--green--large'} onClick={this.submit}>Submit <span className="small-icons next-arrow-white-l"/></HoverButton>
                    </div>
                </div>
            </Fragment>
        )
    }
}